
export const PENDING_FLIGHT_TO_IDEA_STORAGE_KEY = 'pending_flight_to_idea_v1';
export const PENDING_FLIGHT_TO_TRIP_STORAGE_KEY = 'pending_flight_to_trip_v1';
export const PENDING_PLACE_TO_IDEA_STORAGE_KEY = 'pending_place_to_idea_v1';
export const PENDING_PLACE_TO_TRIP_STORAGE_KEY = 'pending_place_to_trip_v1';
export const PENDING_TOUR_TO_IDEA_STORAGE_KEY = 'pending_tour_to_idea_v1';
